// extracted by mini-css-extract-plugin
var _1 = "AIVoiceInput-moduleaiVoiceInput__Rh3tJ AIButtonOutlined-moduleaiButtonOutlined__Yxl0S";
var _2 = "AIVoiceInput-modulestopButton__GT7S_ AIButtonContainedDark-moduleaiButtonContainedDark__jzTWy";
export { _1 as "aiVoiceInput", _2 as "stopButton" }
